<template>
  <v-checkbox
    :input-value="isChecked"
    :label="label"
    dense
    hide-details
    v-bind="$attrs"
    @change="toggle"
  />
</template>

<script>
export default {
  name: "BaseCheckboxItem",
  inject: ["checkboxGroup"],
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
  },
  computed: {
    isChecked() {
      return this.checkboxGroup.value.includes(this.value);
    },
  },
  methods: {
    toggle() {
      const next = [...this.checkboxGroup.value];
      const idx = next.indexOf(this.value);
      if (idx === -1) next.push(this.value);
      else next.splice(idx, 1);
      this.checkboxGroup.$emit("input", next);
    },
  },
};
</script>
